<template lang="pug">
  .wt-media-object.media
    // ENTRY DATE
    .media-left.wt-media-object-left.mr-3
      .journal-created-date
        span(v-if="data.editedDate")
          BTooltip(
            :label="editedJournalDate"
            position="is-right"
            animated
          )
            small *
        span(v-if="$route.name === 'MyDashboard' || isProfile || isNewsfeed")
          RouterLink.has-text-grey(
            :to="{ name: journalPageRoute, params: { username: data.member.username, journalDate: data.created } }"
          )
            .is-size-4 {{ created.split(' ')[1].split(',')[0] }}
            .has-text-grey-light {{ created.split(' ')[0] }}
        small.has-text-grey(v-else)
          .is-size-4 {{ created.split(' ')[1].split(',')[0] }}
          .has-text-grey-light {{ created.split(' ')[0] }}
    // ENTRY CONTENT
    .media-content.wt-media-object-content
      .columns.is-mobile.is-multiline
        // ENTRY HEADER LEFT
        .column.is-narrow
          .columns.is-1.is-variable.is-mobile
            .column.is-narrow
              EntityAvatar(:image="data.member.avatar" :size-class="isMobile ? 'is-48x48' : 'is-48x48'" is-rounded)
            .column.is-narrow
              span.is-size-7
                RouterLink(:to="{ name: 'ProfilePage', params: { username: data.member.username } }")
                  | @{{ data.member.username }}
              span.is-size-6(v-if="coreProgramMeta.showRealNames")
                .has-text-weight-bold {{ data.member.name }}
        // ENTRY METADATA w/ ICONS
        .column.is-narrow.is-flex-grow-1.steps-info(v-if="type === 'journal'")
          .level.is-mobile.is-justify-content-flex-end
            .level-left
            .level-right
              // STEPs ICON
              template
                .level-item
                  .level.level-custom
                    .level-item.mr-2
                      WtSvgIcon(icon="blue-shoe").mr-2
                    .level-item
                      span.level-item-span-custom
                        BTooltip(
                          :active="!!coreProgramMeta.converter"
                          label="Activities not included."
                          position="is-right"
                          animated
                        )
                          .is-size-6.has-text-grey Steps:
                        .is-size-3.make-number-closer-to-text {{ data.todaysSteps.toLocaleString() }}
              // ACTIVITIES ICON
              template(v-if="coreProgramMeta.converter")
                .level-item
                  .level.level-custom
                    .level-item.mr-2
                      WtSvgIcon(icon="blue-walk-man-icon").mr-2
                    .level-item
                      span.level-item-span-custom
                        .is-size-6.has-text-grey.is-inline-flex.is-relative
                          span Activities:
                        .make-number-closer-to-text
                          .is-size-3(v-if="data.activities.length < 1") {{ data.todaysActivities.toLocaleString() }}
                          BDropdown(
                            v-else
                            aria-role="list"
                            position="is-bottom-left"
                          )
                            .activities-dropdown-trigger(slot="trigger")
                              .is-flex.is-flex-direction-row
                                .is-size-3 {{ data.todaysActivities.toLocaleString() }}
                                BIcon(
                                  style="position: relative; top: -3px; left: 3px"
                                  icon="information"
                                  size="is-small"
                                  type="is-grey"
                                  )
                            template(v-for="activity in data.activities")
                              BDropdownItem(
                                aria-role="listitem"
                                :focusable="false"
                                custom
                              )
                                li(
                                  :style="isMobile ? '' : 'min-width: 350px'"
                                ) {{ `${activity.text}, ${activity.steps.toLocaleString()} steps.` }}
              // DISTANCE ICON
              template
                .level-item
                  .level.level-custom
                    .level-item.mr-2
                      WtSvgIcon(icon="purple-mile-marker").mr-2
                    .level-item
                      span.level-item-span-custom
                        BTooltip(
                          :active="!!coreProgramMeta.converter"
                          label="Activities not included."
                          position="is-left"
                          animated
                        )
                          .is-size-6.has-text-grey {{ memberDistanceUnitText }}:
                        .is-size-3.make-number-closer-to-text {{ memberStepsInDistanceUnit(data.todaysSteps) }}


      // BODY OF JOURNAL ENTRY or DISCUSSION POST
      .journal-entry-body.is-inline-block
        //- TODO using imageLarge to accomodate legacy, use data.image when legacy api not used for mobile
        figure.is-pulled-left.mr-4.ml-2(v-if="data.imageLarge")
          BTooltip(
            label="View this image"
            position="is-right"
            animated
          )
            .jounal-entry-body-image.image
              //- TODO using imageLarge to accomodate legacy, use data.image when legacy api not used for mobile
              img.has-radius-large(
                :src="data.imageLarge"
                alt="image"
                @error="imageOnError"
                @click="toggleImageModal"
              )
        .journal-entry-text.has-text-grey.m-2.mb-4.is-size-6(v-html="filteredText(data.text)")

      // COMMENTS JOURNAL ENTRY
      .columns.is-mobile.wt-media-object-comments(
        v-if="commentsAllowed"
        v-for="comment in comments"
        :key="comment.id"
      )
        .column.is-1
        .column.is-11
          .columns.is-multiline.is-mobile
            .column.is-narrow
              .is-flex
                EntityAvatar.mr-1(:image="comment.member.avatar" size-class="is-32x32" is-rounded)
                .columns
                  .column.is-full.is-size-7
                    span(v-if="comment.member.username")
                      RouterLink(:to="{ name: 'ProfilePage', params: { username: comment.member.username } }")
                        | &nbsp;@{{ comment.member.username }}
                    span(v-if="coreProgramMeta.showRealNames")
                      .has-text-weight-semibold {{ comment.member.name }}
            .column.is-narrow.is-justify-content-flex-end.is-flex-grow-1
              .is-flex.is-justify-content-flex-end
                span.is-size-7.has-text-grey.m-1(v-if="comment.edited") (edited)
                span.is-size-7.has-text-grey  {{ commentDate(comment) }}
                .comment-action-menu(
                  v-if="canEditJournalComment(comment.member.id) || canDeleteJournalComment(comment.member.id)"
                )
                  WtActionMenu
                    WtActionMenuItem.has-text-primary(
                      v-if="canEditJournalComment(comment.member.id)"
                      icon="settings"
                      text="Edit"
                      @click.native="editJournalComment(comment.id)"
                    )
                    WtActionMenuItem.has-text-danger(
                      v-if="canDeleteJournalComment(comment.member.id)"
                      icon="delete"
                      text="Delete"
                      @click.native="deleteComment(comment.id)"
                  )
          // COMMENT TEXT
          template
            Transition(name="slide-fade")
              // COMMENT VIEW
              .comment-text-container.columns.is-mobile(
                :key="comment.id+'-viewing'"
                v-if="!editingJournalComment || editingJournalCommentId !== comment.id"
              )
                .column.is-1
                .column.is-10.comment-text.pt-0
                  .has-text-black.is-size-7(v-html="filteredText(comment.text)")

              // EDIT COMMENT
              .comment-text-container.columns(
                :key="comment.id+'-editing'"
                v-if="editingJournalComment && editingJournalCommentId === comment.id"
              )
                .comment-text.column.content
                  BField
                      BInput(
                        v-focus
                        type="textarea"
                        maxlength="1000"
                        v-model="updatedComment"
                      )
                .comment-action-buttons.column.is-narrow
                  .level.is-mobile
                    .level-left
                      .comment-delete.level-item(
                          v-if="canDeleteJournalComment(comment.member.id)"
                      )
                        WtButton(
                          color="grey"
                          isText
                          @click.native="editingJournalComment = false"
                        ) Cancel
                      .comment-edit.level-item(v-if="canEditJournalComment(comment.member.id)")
                        WtButton(
                          outlined
                          type="submit"
                          @click.native="updateJournalComment(comment.id)"
                        ) Save

      // COMMENT ON JOURNAL ENTRY
      .wt-media-object-add-comment(v-if="commentsAllowed && !showCommentField && checkFriendsOnly(data.member)")
        a.has-text-weight-semibold(@click="toggleCommentField")
          BIcon(icon="comment" size="is-small").mr-2
          span comment

      // SUBMIT A COMMENT
      Transition(name="expand")
        .comment-field(v-if="showCommentField").mr-1.ml-1
          BField(:type="{ 'is-danger': errors.has('comment') }"
            :message="errors.first('comment')")
              BInput(
                v-focus
                name="comment"
                maxlength="1000"
                type="textarea"
                v-model="newComment"
                v-validate.disable="'required'"
              )
          .buttons.level.is-mobile
            .level-left
              .level-item
                WtButton(
                  color="grey"
                  is-text
                  @click.native="toggleCommentField"
                ) Cancel
              .level-item
                WtButton(
                  @click.native="storeNewComment"
                  type="submit"
                ) Submit
    .media-right.wt-media-object-right.ml-0
      // VISIBILITY ICONS
      small(
        v-if="data.visibility === 0 && data.member.id === $auth.user().id"
      )
        BTooltip(
          label="Private Post"
          position="is-left"
          animated
        )
          BIcon(icon="lock" size="is-small")
      small(
        v-if="data.visibility === 1 && data.member.id === $auth.user().id"
      )
        BTooltip(
          label="Friends Only Post"
          position="is-left"
          animated
        )
          BIcon(icon="account-multiple" size="is-small")
      // JOURNAL EDIT
      a(
        @click="openModal({ entryItem: data, type, entityId, ...pageInfo })"
        v-if="type === 'journal' && canEditJournalEntry && !isProfile"
      )
        BIcon(icon="dots-horizontal")
      // DISCUSSION POST edit/delete
      WtActionMenu(
        v-if="type === 'discussion' && (data.member.id === $auth.user().id || isAdmin)"
      )
        WtActionMenuItem.has-text-primary(
          v-if="data.member.id === $auth.user().id"
          icon="settings"
          text="Edit"
          @click.native="openModal({ entryItem: data, type, entityId, ...pageInfo })"
        )
        WtActionMenuItem.has-text-danger(
          v-if="data.member.id === $auth.user().id"
          icon="delete"
          text="Delete"
          @click.native="deleteDiscussionPostAction(data.id)"
        )

    // IMAGE DETAIL
    BModal(:active.sync="showImageModal")
      p.image
        img(
          :src="data.imageLarge"
          alt="journal image"
          @error="imageOnError"
        )
</template>

<script>
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import BInputFocus from "@/directives/BInputFocus";
import WtButton from "@@/WtButton/WtButton";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";

const MakeAnEntryModal = () =>
  import(
    /* webpackChunkName: "MakeAnEntryModal" */ "@@/Members/MakeAnEntry/MakeAnEntryModal"
  );

export default {
  name: "WtMediaObject",

  components: {
    WtActionMenu,
    WtActionMenuItem,
    WtButton,
    WtSvgIcon,
    MakeAnEntryModal,
    EntityAvatar
  },

  directives: {
    focus: BInputFocus
  },

  mixins: [dateUtilityMixin],

  props: {
    // "journal" or "discussion"
    type: {
      type: String,
      default: "journal",
      required: true
    },

    data: {
      type: Object,
      required: true
    },

    storeCommentAction: {
      type: Function,
      default: () => {}
    },

    editCommentAction: {
      type: Function,
      default: () => {}
    },

    deleteCommentAction: {
      type: Function,
      default: () => {}
    },

    deleteDiscussionPostAction: {
      type: Function,
      default: () => {}
    },

    // needed for editing discussion which uses the makeAnEntryModal
    challengeId: {
      type: Number,
      default: null
    },

    // needed for editing discussion which uses the makeAnEntryModal
    teamId: {
      type: Number,
      default: null
    },

    pageInfo: {
      type: Object,
      default: () => {}
    },

    isNewsfeed: {
      type: Boolean,
      default: false
    },

    isProfile: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showCommentField: false,
      newComment: "",
      showImageModal: false,
      isEditModalActive: false,
      editingJournalComment: false,
      editingJournalCommentId: null,
      updatedComment: "",
      comments: []
    };
  },

  computed: {
    ...mapGetters(["isMobile"]),
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapGetters("members", ["member", "memberLoaded", "memberFriends"]),
    ...mapGetters("program", ["coreProgramMeta"]),

    entityId() {
      if (this.challengeId) {
        return { id: this.challengeId, type: "challenge" };
      }
      if (this.teamId) {
        return { id: this.teamId, type: "team" };
      }
      return null;
    },

    journalPageRoute() {
      return (this.isProfile || this.isNewsfeed) &&
        this.data.member.id !== this.$auth.user().id
        ? "ProfileJournalPage"
        : "JournalPage";
    },

    commentsAllowed() {
      return this.programAllowsComments && this.memberAllowsComments;
    },

    programAllowsComments() {
      if (this.type === "journal") {
        return this.coreProgramMeta.allowCommentsOnMemberJournals;
      }

      return false;
    },

    allowCommentsSetting() {
      return this.data.memberAllowComments;
    },

    memberAllowsComments() {
      if (this.type === "journal") {
        const allowed = this.allowCommentsSetting;

        if (allowed === "Yes" || allowed === "Com") {
          return true;
        }
        if (allowed === "No") {
          return false;
        }
      }

      return false;
    },

    friendIds() {
      const friendsArray = this.memberFriends;
      const ids = friendsArray.map(friend => friend.id);

      // make sure auth users' own id is present so they can comment on their own entries
      ids.push(this.$auth.user().id);

      return ids;
    },

    canEditJournalEntry() {
      if (this.type === "journal" && !this.isNewsfeed) {
        // Journal Entry can only be edited by:
        //  * entry submitter
        return (
          this._.get(this.data, "member.id", null) === this.$auth.user().id
        );
      }

      if (this.type === "discussion") {
        return this.data.member.id === this.$auth.user().id;
      }

      return false;
    },

    created() {
      if (this.type === "journal") {
        return this.date(this.data.created, "DATE_FORMAT_SHORT_MONTH")
          .formatted;
      }

      if (this.type === "discussion") {
        return this.unixDateTime(this.data.postedDate).formatted;
      }

      return null;
    },

    editedJournalDate() {
      return this.date(this.data.edited, "DATE_TIME_FORMAT").formatted;
    },

    memberDistanceUnit() {
      return this._.get(this.$auth.user(), "memberData.units", "Miles");
    },

    memberDistanceUnitText() {
      return this.memberDistanceUnit;
    }
  },

  mounted() {
    if (this.data && this.data.comments) {
      this.comments = [...this.data.comments];
    }
  },

  methods: {
    openModal(props) {
      this.$buefy.modal.open({
        parent: this,
        props: props,
        component: MakeAnEntryModal,
        hasModalCard: true
      });
    },

    toggleCommentField() {
      this.newComment = "";

      return (this.showCommentField = !this.showCommentField);
    },

    toggleImageModal() {
      return (this.showImageModal = !this.showImageModal);
    },

    storeNewComment() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          const payload = {
            itemId: this.data.id,
            text: this.newComment,
            profileId: this.data.member.id // used for JournalPage
          };

          await this.storeCommentAction(payload);

          this.showCommentField = false;
        }
      });
    },

    async updateJournalComment(commentId) {
      const payload = {
        itemId: commentId,
        text: this.updatedComment,
        profileId: this.data.member.id // used for JournalPage
      };

      await this.editCommentAction(payload);

      const commentIndex = this.comments.findIndex(
        comment => comment.id === commentId
      );
      if (commentIndex !== -1) {
        const currentTime = new Date().toISOString();

        this.comments[commentIndex].text = this.updatedComment;
        this.comments[commentIndex].edited = currentTime;

        this.comments = [...this.comments];
      }

      this.editingJournalComment = false;
      this.editingJournalCommentId = null;
      this.updatedComment = "";
    },

    editJournalComment(commentId) {
      const comment = this.comments.find(comment => comment.id === commentId);
      if (comment) {
        this.editingJournalComment = true;
        this.editingJournalCommentId = commentId;
        this.updatedComment = comment.text;
      }
    },

    canEditJournalComment(commentMemberId) {
      // Comments can be edited by:
      //  * commenter

      return commentMemberId === this.$auth.user().id;
    },

    checkFriendsOnly(member) {
      // When member has commenting on their entries set to "friends only"
      // the auth user must be one of their friends
      if (this.allowCommentsSetting === "Com") {
        return this.friendIds.includes(member.id);
      }

      return true;
    },

    async deleteComment(commentId) {
      const payload = {
        itemId: commentId,
        profileId: this.data.member.id // used for JournalPage
      };

      this.deleteCommentAction(payload);
    },

    canDeleteJournalComment(commentMemberId) {
      // Comments can be deleted by:
      //  * commenter
      //  * admin

      return commentMemberId === this.$auth.user().id || this.isAdmin;
    },

    commentDate(comment) {
      // note, comment.date is mysql-type TIMESTAMP, and thus is always updated,
      // meaning, if the comment is edited, 'edited' and 'created' will be the same
      // and hence, if the comment has been edited, we only display the 'edited' date
      // and not both the 'created' and 'edited' dates
      if (comment.edited) {
        return this.date(comment.edited, "DATE_TIME_FORMAT").formatted;
      }

      return this.date(comment.date, "DATE_TIME_FORMAT").formatted;
    },

    imageOnError(event) {
      event.target.onerror = null;
      event.target.src =
        "https://walkertracker.s3.amazonaws.com/avatars/anonymous.png";
    },

    filteredText(text) {
      return this.sanitize(text, {
        allowedTags: [],
        allowedAttributes: {}
      });
    },

    memberStepsInDistanceUnit(steps) {
      let stride = this._.get(this.data, "memberStrideLength", 26) || 26;
      let feet = (stride * steps) / 12;
      let distance = feet / 5280; // Miles

      if (this.memberDistanceUnit === "Kilometers") {
        return (distance * 1.609344).toFixed(1);
      }

      return distance.toFixed(1);
    }
  }
};
</script>

<style lang="sass" scoped>
.wt-media-object
  .level-custom
    @media screen and (max-width: 1190px)
      display: block
  .level-item-span-custom
    height: 50px
    .make-number-closer-to-text
      line-height: 1
  .has-radius-large
    border-radius: $radius-large
  .media-content
    flex-basis: 0 // IE11 fix
    +mobile
      overflow: hidden // fyi, to prevent the default scroll behavior
  .journal-entry-body
    width: 100%
    .jounal-entry-body-image
      border-radius: $radius-large
      max-height: 360px
      max-width: 360px
      overflow: hidden
      &:hover
        cursor: pointer
  .comment-field
    max-height: 15rem
  .expand-enter-active
    transition: all .4s ease
  .expand-enter
    transform: translateY(10px)
    max-height: 0
    opacity: 0
  .slide-fade-enter-active
    transition: all .4s ease
    max-height: 15rem
  .slide-fade-enter
    transform: translateX(4px)
    max-height: 0
    opacity: 0
  .activities-dropdown-trigger
    &:hover
      cursor: pointer
  .username-mention
    color: $lightgrey
    &:hover
      color: $black
</style>
